/** Normalize legacy member level names to VIP0 / VIP1 / VIP2 ... */
export function formatVipLevel(name) {
	if (!name || typeof name !== 'string') {
		return 'VIP0';
	}
	const trimmed = name.trim();
	if (!trimmed || trimmed === '普通会员' || trimmed.indexOf('普通') >= 0) {
		return 'VIP0';
	}
	const vMatch = trimmed.match(/^V(\d+)$/i);
	if (vMatch) {
		return 'VIP' + vMatch[1];
	}
	return trimmed;
}
